import React, { PropTypes } from 'react';
import { BAM_PAYWALL_IFRAME_ID } from 'constants';

const Paywall = (props) => {
    const { src } = props;
    const content = src && <iframe src={src} />;

    return (
        <div id={BAM_PAYWALL_IFRAME_ID} style={{ width: '100%', height: '100%', overflow: 'auto' }}>
            {content}
        </div>
    );
};

Paywall.propTypes = {
    src: PropTypes.string
};

export default Paywall;



// WEBPACK FOOTER //
// ./app/webapp/modal/messaging/Paywall.js